import React from "react";
import { Link } from "react-router-dom";

function SearchItem(props) {
  let topicDetail = props?.topicDetail;
  return (
    <div style={{ clear: "both", padding: "1px" }}>
      {topicDetail.map((topic, i) => {
        let topic_content = topic?.highlight?.topic_content.join(" ... ");
        let topic_title = topic?.highlight?.topic_title ? topic?.highlight?.topic_title : topic?._source?.topic_title;
        let specialty = topic?._source?.speciality
          ? topic?._source?.speciality[0].replace(/[^a-zA-Z0-9]/g, "-")
          : "undefined";
        return (
          <div className="search-result-box" key={i}>
            <p className="search-result-box-heading">
              <Link
                to={`/topic/${specialty}/${topic?._source?.topic_id}`}
                dangerouslySetInnerHTML={{ __html: topic_title }}
              />
            </p>
            <p
              className="search-result-box-about"
              dangerouslySetInnerHTML={{ __html: topic_content }}
            />
            <p className="search-result-box-book-title">
              {topic?._source?.book_title}
            </p>
          </div>
        );
      })}
    </div>
  );
}
export default SearchItem;
